export default __webpack_public_path__ + "static/media/notfound.2e379e87.svg";